
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  PhotosApi,
  Workorder,
  PhotographPagedCollectionApiResponse,
  Photograph
} from 'performo-api';
import DeletePhoto from './DeletePhoto.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    DeletePhoto
  },
  computed: mapGetters({
    photosApi: 'photosApi'
  })
})
export default class PhotoCarousel extends Vue {
  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false, default: true })
  private canEdit!: boolean;

  private photosApi!: PhotosApi;

  private photoSource(photo: Photograph) {
    if (!photo) return null;
    if (!photo.photo) return null;
    if (photo.photo.length <= 0) return null;
    return window.URL.createObjectURL(photo.photo);
  }

  private loading = true;

  private photos!: PhotographPagedCollectionApiResponse;
  private currentPhotoIndex = 0;

  data() {
    return {
      photos: undefined
    };
  }

  async mounted() {
    await this.loadPhotos();
  }

  get currentPhoto() {
    if (this.photos && this.photos.data) {
      return this.photos.data[this.currentPhotoIndex];
    } else {
      return null;
    }
  }

  @Watch('order', { deep: true })
  async loadPhotos() {
    this.loading = true;
    this.photos = await this.photosApi.queryPhotos({
      workorderId: this.order.workorderId?.toString(),
      includeContainerData: true
    });
    this.loading = false;
  }

  private async photoDeletedHandler() {
    await this.loadPhotos();
  }
}
